import Pikaday from 'pikaday/pikaday.js';

const BookRoomConfig = {
    className: 'book-a-room',
    classNameBtnGroup: 'book-a-room__btn-group',
    checkAvailabilityBtn: 'js-book-a-room__cta',
    classHotelSelector: 'js-hotel-selector',
    roomsCountDisplayText: 'js-roomCount',
    adultsCountDisplayText: 'js-adultCount'
};

const BookRoom = {

    Config: BookRoomConfig,
    init(component) {
        this.initBookingDataStore(component);
        this.updateUrl(component);
        this.initCalendars(component);
        this.addEvents(component);
    },

    getAll(container = document) {
        return container.querySelectorAll('.' + this.Config.className);
    },
    getHotelSelector(component) {
        return component.getElementsByClassName(this.Config.classHotelSelector)[0] || false;
    },
    initAll(container = document) {
        const components = this.getAll(container);
        [].forEach.call(components, component => {
            this.init(component);
        });
        const dropDownContainers = document.getElementsByClassName(BookRoom.Config.classNameBtnGroup);
        if (dropDownContainers.length > 0)
            this.initDropDownContainers();
    },
    addEvents(component) {
        component.addEventListener('click', this.onClick.bind(this, component));
    },
    handlePlusMinusClick(target, action, component) {
        switch (action) {
            case "subtract":
                if (component.bookingData[target] > 1)
                    component.bookingData[target]--;
                break;
            case "add":
                component.bookingData[target]++;
                break;
        }

    },
    onClick(component, e) {
        let action = e.target.dataset.action;
        let target = e.target.dataset.target;
        let bookingUrl = e.target.dataset.bookingurl;
        let hotelId = e.target.dataset.hotelid;
        let chainId = e.target.dataset.chainid;

        if (hotelId && chainId) {
            component.bookingData.bookingUrl = bookingUrl;
            component.bookingData.hotelID = hotelId;
            component.bookingData.chainID = chainId;
        }
        if (action === "subtract" || action == "add") {
            this.handlePlusMinusClick(target, action, component);
        }

    },

    initBookingDataStore(component) {
        let today = new Date();
        let twoDaysFromNow = new Date();
        twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 2);

        component.bookingData = {
            _bookingUrl: component.dataset.bookingurl,
            _hotelID: component.dataset.hotelid,
            _chainID: component.dataset.chainid,
            _arriveDate: today.toLocaleDateString("en-US"),
            _departDate: twoDaysFromNow.toLocaleDateString("en-US"),
            _adultsNum: 2,
            _roomsNum: 1,
            get bookingUrl() {
                return this._bookingUrl;
            },
            set bookingUrl(val) {
                this._bookingUrl = val;
                BookRoom.updateUrl(component);
            },
            get hotelID() {
                return this._hotelID;
            },
            set hotelID(val) {
                this._hotelID = val;
                BookRoom.updateUrl(component);
            },
            get chainID() {
                return this._chainID;
            },
            set chainID(val) {
                this._chainID = val;
                BookRoom.updateUrl(component);
            },
            get arriveDate() {
                return this._arriveDate;
            },
            set arriveDate(val) {
                this._arriveDate = val;
            },
            get departDate() {
                return this._departDate;
            },
            set departDate(val) {
                this._departDate = val;
            },
            get adultCount() {
                return this._adultsNum;
            },
            set adultCount(val) {
                this._adultsNum = val;
                BookRoom.updateUrl(component);
            },
            get roomCount() {
                return this._roomsNum;
            },
            set roomCount(val) {
                this._roomsNum = val;
                BookRoom.updateUrl(component);
            }

        };
        //if we have a hotelSelector added to DOM, get the checked values and set default hotel/chain ID's accordingly
        const hotelSelector = this.getHotelSelector(component);
        if (hotelSelector) {
            const checkedInput = hotelSelector.querySelector('input:checked');
            component.bookingData.bookingUrl = checkedInput.dataset.bookingurl;
            component.bookingData.hotelID = checkedInput.dataset.hotelid;
            component.bookingData.chainID = checkedInput.dataset.chainid;
        }
    },

    initCalendars(component) {

        let twoDaysFromNow = new Date();
        twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 2);
        let componentID = component.dataset.id;
        let i18nFormat = {
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
        };
        let vars = {};
        component.startDate = "";
        component.endDate = "";
        component.fieldStartDate = component.querySelector('.datepickerStartDate'),
            component.fieldEndDate = component.querySelector('.datepickerEndDate');
        vars["checkInCalendar" + componentID] = new Pikaday({
            i18n: i18nFormat,
            firstDay: 0,
            minDate: new Date(),
            maxDate: new Date((new Date()).getFullYear() + 10, 12, 31),
            setDefaultDate: true,
            defaultDate: new Date(),
            bound: false,
            numberOfMonths: screenSize(),
            format: 'D/M/YYYY',
            toString(date) {
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return `${month}/${day}/${year}`;
            },
            onSelect: function() {
                component.startDate = vars["checkInCalendar" + componentID].getDate();
                component.updateStartDate();
                component.bookingData.arriveDate = this.toString();
                //when we select a date move "check out" date two days ahead
                let newEndDate = new Date(component.startDate);
                newEndDate.setDate(newEndDate.getDate() + 2);
                //set our end range for the stay
                component.endDate = new Date(newEndDate.getTime());
                //make the "Check out" calendar update itself
                vars["checkOutCalendar" + componentID].setDate(component.endDate);
                component.updateEndDate();
                component.bookingData.departDate = vars["checkOutCalendar" + componentID].toString();
                BookRoom.updateUrl(component);

            }
        });
        vars["checkOutCalendar" + componentID] = new Pikaday({
            i18n: i18nFormat,
            firstDay: 0,
            minDate: new Date(),
            numberOfMonths: screenSize(),
            maxDate: new Date((new Date()).getFullYear() + 10, 12, 31),
            yearRange: [(new Date()).getFullYear(), (new Date()).getFullYear() + 10],
            bound: false,
            format: 'D/M/YYYY',
            setDefaultDate: true,
            defaultDate: twoDaysFromNow,
            toString(date) {
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return `${month}/${day}/${year}`;
            },
            onSelect: function() {
                component.endDate = vars["checkOutCalendar" + componentID].getDate();
                component.updateEndDate();
                component.bookingData.departDate = this.toString();
                BookRoom.updateUrl(component);
            }
        });

        function screenSize() {
            if (window.innerWidth > 480) {
                return 2;
            }
            if (window.innerHeight < 480) {
                return 1;
            }
            return null;
        }

        component.updateStartDate = function() {
            vars["checkOutCalendar" + componentID].setStartRange(component.startDate);
            vars["checkOutCalendar" + componentID].setMinDate(component.startDate);
        };
        component.updateEndDate = function() {
            //  checkInCalendar.setEndRange(endDate);
            // checkInCalendar.setMaxDate(endDate);
            vars["checkOutCalendar" + componentID].setEndRange(component.endDate);
            vars["checkOutCalendar" + componentID].hide();
            vars["checkOutCalendar" + componentID].show();
        };

        //add to dom
        component.fieldStartDate.parentNode.insertBefore(vars["checkInCalendar" + componentID].el, component.fieldStartDate.nextSibling);

        component.fieldEndDate.parentNode.insertBefore(vars["checkOutCalendar" + componentID].el, component.fieldEndDate.nextSibling);

        var _startDate = vars["checkInCalendar" + componentID].getDate(),
            _endDate = vars["checkOutCalendar" + componentID].getDate();

        if (_startDate) {
            component.startDate = _startDate;
            component.updateStartDate();
        }

        if (_endDate) {
            component.endDate = _endDate;
            component.updateEndDate();
        }

    },
    initDropDownContainers() {
        //bootstrap dropdown specifics to handle mobile appearance
        $(document).on("shown.bs.dropdown", ('.' + this.Config.classNameBtnGroup), function() {
            // calculate the required sizes, spaces
            var $ul = $(this).children(".dropdown-menu");
            var $button = $(this).children(".dropdown-toggle");
            var ulOffset = $ul.offset();
            // how much space would be left on the top if the dropdown opened that direction
            var spaceUp = (ulOffset.top - $button.height() - $ul.height()) - $(window).scrollTop();
            // how much space is left at the bottom
            var spaceDown = $(window).scrollTop() + $(window).height() - (ulOffset.top + $ul.height());
            // switch to dropup only if there is no space at the bottom AND there is space at the top, or there isn't either but it would be still better fit
            if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown))
                $(this).addClass("dropup");
        }).on("hidden.bs.dropdown", ".dropdown", function() {
            // always reset after close
            $(this).removeClass("dropup");
        });

        //prevent clicks on any part of componet from dismissing the dropdown
        $('.' + this.Config.classNameBtnGroup + ' .dropdown-menu').click(function(e) {
            e.stopPropagation();
        });
        $('.' + this.Config.classNameBtnGroup + ' .close').click(function() {
            $("body").trigger("click");
        });
        $('.' + this.Config.classNameBtnGroup + ' .dropdown-menu a[data-toggle="tab"]').click(function(e) {
            e.stopPropagation();
            $(this).tab('show');
        });
    },
    updateUrl: function(component) {
        let sabreURL = component.bookingData.bookingUrl + "?Hotel=" + component.bookingData.hotelID + "&Chain=" + component.bookingData.chainID + "&template=RBE&shell=RBE&start=availresults&arrive=" + component.bookingData.arriveDate + "&depart=" + component.bookingData.departDate + "&adult=" + component.bookingData.adultCount + "&rooms=" + component.bookingData.roomCount;
        [].forEach.call(component.querySelectorAll("." + this.Config.checkAvailabilityBtn), function(a) {
            a.href = sabreURL;
        });

        component.querySelector("." + this.Config.adultsCountDisplayText).textContent = (component.bookingData.adultCount > 1) ? `${component.bookingData.adultCount} Adults` : "1 Adult";
        component.querySelector("." + this.Config.roomsCountDisplayText).textContent = (component.bookingData.roomCount > 1) ? `${component.bookingData.roomCount} Rooms` : "1 Room";
    }

}

document.addEventListener('DOMContentLoaded', () => {
    BookRoom.initAll();
});
